"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var bytes = _interopRequireWildcard(require("../../../helpers/byte-helpers"));

var _packetHeader = _interopRequireDefault(require("./packet-header"));

var _pat = _interopRequireDefault(require("./pat"));

var _pmt = _interopRequireDefault(require("./pmt"));

var _packet = require("./packet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TransportStreamParser =
/*#__PURE__*/
function () {
  function TransportStreamParser() {
    _classCallCheck(this, TransportStreamParser);

    this.PAT = undefined;
    this.PMT_ID = undefined;
    this.trackPIDs = [];
  }

  _createClass(TransportStreamParser, [{
    key: "parse",
    value: function parse(arrayBuffer) {
      var bitReader = new bytes.BitReader(arrayBuffer);
      var header = new _packetHeader.default(bitReader); // 0 Signals we have a PAT

      if (header.PID === 0) {
        var pat = new _pat.default(header, bitReader);
        this.pmtPID = pat.pmtID;
        return pat;
      } else if (header.PID === this.pmtPID) {
        var pmt = new _pmt.default(header, bitReader);

        if (pmt.programs.length <= 0) {
          throw 'Program Map Table had no programs listed';
        }

        this.tracks = pmt.programs[0].tracks;
        this.trackPIDs = this.tracks.map(function (t) {
          return t.elementaryPID;
        }); // console.log(pmt.programs[0].tracks);

        return pmt;
      } else if (this.trackPIDs.includes(header.PID)) {
        var track = this.tracks.filter(function (t) {
          return t.elementaryPID === header.PID;
        })[0];
        var mediaPacket = new _packet.MediaPacket(header, bitReader, track.streamType);
        return mediaPacket;
      } else {
        console.log('[Unknown transport stream packet] - ', header);
      }
    }
  }]);

  return TransportStreamParser;
}();

var _default = TransportStreamParser;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/ts/parser.js
// module id = 472
// module chunks = 0